{
  "name": "front-support",
  "version": "1.2.1",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "build": "ng build && npm run sentry:sourcemaps",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org megakit --project utax-support ./dist/front-support/browser && sentry-cli --url https://sentry.megakit.pro/ sourcemaps upload --org megakit --project utax-support ./dist/front-support/browser"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^19.0.0",
    "@angular/cdk": "^19.2.1",
    "@angular/common": "^19.0.0",
    "@angular/compiler": "^19.0.0",
    "@angular/core": "^19.0.0",
    "@angular/forms": "^19.0.0",
    "@angular/material": "^19.0.0",
    "@angular/platform-browser": "^19.0.0",
    "@angular/platform-browser-dynamic": "^19.0.0",
    "@angular/router": "^19.0.0",
    "@flowjs/flow.js": "^2.14.1",
    "@flowjs/ngx-flow": "^19.0.0",
    "@ngx-translate/core": "^17.0.0",
    "@ngx-translate/http-loader": "^17.0.0",
    "@sentry/angular": "^9.22.0",
    "@sentry/cli": "^2.45.0",
    "@types/flowjs": "^2.13.14",
    "moment": "^2.30.1",
    "moment-timezone": "^0.5.47",
    "ng-gallery": "^12.0.0-beta.4",
    "ngx-infinite-scroll": "^19.0.0",
    "ngx-pipes": "^3.2.2",
    "ngx-webstorage": "^18.0.0",
    "rxjs": "~7.8.0",
    "tslib": "^2.3.0",
    "uuid": "^11.1.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^19.0.1",
    "@angular/cli": "^19.0.1",
    "@angular/compiler-cli": "^19.0.0",
    "@types/flowjs__flow.js": "^2.13.3",
    "@types/jasmine": "~5.1.0",
    "@types/node": "^22.15.21",
    "jasmine-core": "~5.4.0",
    "karma": "~6.4.0",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.0",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "typescript": "~5.6.2"
  }
}
